<script>
import AppDocumentos from '@/components/AppDocumentos.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'

export default {
  components: {
    AppDocumentos,
    TitleWithRow
  },

  props: {
    cadastro: {
      type: Object,
      required: true
    },
    pathDocumentosRemover: {
      type: Array,
      required: true
    }
  },

  computed: {
    fotos () {
      return this.cadastro?.fotos
    },
    tiposDocumentosObrigatorios () {
      if (this.cadastro.praticas) {
        return Object.keys(this.cadastro.praticas).map((key, index) => {
          const value = this.cadastro.praticas[key]
          if (value === null || (Array.isArray(value) && value.length === 0)) {
            return null
          }
          return {
            id: index,
            codigo: key.replace('praticaSustentavel', 'PRATICA_'),
            descricao: `Prática ${key.replace('praticaSustentavel', '')}`
          }
        }).filter(item => item !== null)
      }
      return []
    },
    tiposDocumentos () {
      const outros = {id: 0, codigo: 'OUTROS', tipo: 'OUTROS', descricao: 'Outros'}
      if (this.tiposDocumentosObrigatorios.length) {
        const tipos = [...this.tiposDocumentosObrigatorios]
        tipos.push(outros)
        return tipos
      }
      return [outros]
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Anexos de imagens" />
    <p class="mb-2 font-size-1">Selecione as fotos que você deseja utilizar</p>
    <app-documentos
      :maxSize='25000'
      :valid-extensions="['jpg', 'jpeg', 'png', 'heic', 'heif']"
      :documentos="fotos"
      :tiposDocumentos="tiposDocumentos"
      :tiposDocumentosObrigatorios="tiposDocumentosObrigatorios"
      aba="Galeria"
      :visualizarlabelTitulo="false"
      :pathDocumentosRemover="pathDocumentosRemover"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.erro {
  font-size: small;
  color: $color-error;
}
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/anexos/anexos.vue